import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { ColorUtils } from "../utils/ColorUtils";
import { CSSProperties } from "react";

export interface Props {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  size?: any;
  customStyle?: CSSProperties;
}

export const CheckboxComponent = ({ label, checked, disabled, size, onChange, customStyle }: Props) => {
  return (
    <FormGroup>
      <FormControlLabel
        label={<Typography color={!checked ? ColorUtils.MEDIUM_GRAY : "default"}>{label || ""}</Typography>}
        control={
          <Checkbox
            disabled={disabled}
            checked={checked}
            onChange={() => onChange()}
            sx={{
              "& .MuiSvgIcon-root": { fontSize: size },
              color: ColorUtils.MEDIUM_GRAY,
              "&.Mui-checked": { color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING },
            }}
          />
        }
        style={{ ...customStyle }}
      />
    </FormGroup>
  );
};
